// import { usePageInfo } from 'global/cnr/contexts/useHelpers/usePageInfo';
import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders';
import React, { useContext, useEffect, useState } from 'react';
import ActionProvider from '../cnr/contexts/ActionContext';
import AlphaProvider from '../cnr/contexts/AlphaContext';
import DataProvider from '../cnr/contexts/DataContext';
import FilterProvider from '../cnr/contexts/FilterContext';
import ItemStorageProvider from '../cnr/contexts/ItemStorageContext';
import { PapsContext } from '../cnr/contexts/PapsContext';
import UiItemProvider, { UiItemContext } from '../cnr/contexts/UiItemContext';
import ErrorBoundaryWithNavigate from '../components/errorHandling/ErrorBoundaryWithNavigate';
import { gEnums } from '../enums/globalEnums';
import UiItem from '../pageItem/UiItem';

const NonAuthPage = React.lazy(() => import("../components/alerts/NonAuthPage"));
const PageItemAlt = React.lazy(() => import("./PageItemAlt"));
const UnderMaintenancePage = React.lazy(() => import("../components/alerts/UnderMaintenancePage"));

// PageItem 
// > DataProvider 
// > ActionProvider 
// > FilterProvider 
// > AlphaProvider 
// > UiItemProvider 
// > ItemStorageProvider
// > UiItem
// > ItemWrapper
// > SemUI

const PageItem = (props) => {

  const { uivi, tabIndex, caption, inSwiper, isMounted } = props;

  const [isPageItemLoaded, setIsPageItemLoaded] = useState(false);

  const papsContext = useContext(PapsContext);
  const { history } = papsContext ?? {};

  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { pageItemInfo, _display } = item_state ?? {};

  useRenders('PageItem', true, true, pageItemInfo)

  const { general, _viewPermissionType, display, desktopDisplay } = pageItemInfo ?? {};

  // const _display = desktopMode && desktopDisplay ? desktopDisplay : display;
  const { displayType } = _display ?? {};
  const { itemUnderMaintenance } = general ?? {};

  // ✅ Run effect unconditionally
  useEffect(() => {
    if (isPageItemLoaded) return;
    if (inSwiper && !isMounted) return;
    setIsPageItemLoaded(true);
  }, [isMounted, inSwiper, isPageItemLoaded]);

  // 🔽 Render logic ONLY below here

  if (itemUnderMaintenance) {
    return <UnderMaintenancePage itemType="item" />;
  }

  switch (_viewPermissionType) {
    case gEnums.viewPermissionTypes.deny:
    case gEnums.viewPermissionTypes.deny_noClientKey:
    case gEnums.viewPermissionTypes.deny_noEventKey:
      return <NonAuthPage history={history} itemType="item" vpt={_viewPermissionType} />;
    default:
      break;
  }

  const altTypes = gEnums.additionalPageItemTypes;

  if (Object.values(altTypes).includes(displayType)) {
    return <PageItemAlt viewItem_page={pageItemInfo} displayType={displayType} />;
  }

  return <UiItem
    tabIndex={tabIndex}
    caption={caption}
    uivi={uivi}
  />

};

export default PageItem

export const PageItem_withProvider = (props) => {
  const { uivi } = props;
  return <ErrorBoundaryWithNavigate origin="pageItem">
    <DataProvider uivi={uivi}>
      <ActionProvider >
        <FilterProvider>
          <AlphaProvider>
            {/* vld_data does not existing until UiItemProvider*/}
            <UiItemProvider uivi={uivi}>
              <ItemStorageProvider>
                <PageItem props={props} />
              </ItemStorageProvider>
            </UiItemProvider>
          </AlphaProvider>
        </FilterProvider>
      </ActionProvider>
    </DataProvider>
  </ErrorBoundaryWithNavigate>
} 